<!-- Vehicles Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Vehicles Management</h3>
    </div>

    <!-- Card Toolbar -->
    <div class="card-toolbar">
      <!-- Filter Button -->
      <div class="d-flex justify-content-end me-3">
        <button type="button" class="btn btn-sm btn-dark fw-bold d-flex" [class.active]="showFiltersForm"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Filter</span>
        </button>
      </div>

      <!-- Search Input -->
      <div class="d-flex align-items-center position-relative me-3">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-4">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input type="text" class="form-control form-control-solid w-250px ps-12" placeholder="Search vehicles..."
          [(ngModel)]="searchTerm" (keyup.enter)="applyFilters()" />
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFiltersForm" [@slideInOut]>
    <div class="row g-4">
      <!-- Row 1: Basic Vehicle Info -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Make</label>
        <app-searchable-select
          [options]="makesList"
          placeholder="All Makes"
          [(ngModel)]="filters.make"
          (selectionChange)="onMakeSelectionChange($event)"
          size="sm"
          [clearable]="true">
        </app-searchable-select>
      </div>
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Model</label>
        <app-searchable-select
          [options]="modelsList"
          placeholder="All Models"
          [(ngModel)]="filters.model"
          (selectionChange)="onModelSelectionChange($event)"
          size="sm"
          [clearable]="true"
          [disabled]="!filters.make">
        </app-searchable-select>
      </div>
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Model Code</label>
        <app-searchable-select
          [options]="modelCodesList"
          placeholder="All Model Codes"
          [(ngModel)]="filters.model_code"
          size="sm"
          [clearable]="true"
          [disabled]="!filters.model">
        </app-searchable-select>
      </div>
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Keyword</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.keyword" placeholder="Search keyword...">
      </div>

      <!-- Row 2: Year and Price -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Year From</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.year_from">
          <option value="">Any Year</option>
          <option *ngFor="let year of yearOptions" [value]="year.value">{{ year.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Year To</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.year_to">
          <option value="">Any Year</option>
          <option *ngFor="let year of yearOptions" [value]="year.value">{{ year.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Price From</label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="filters.price_from" placeholder="Min Price">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Price To</label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="filters.price_to" placeholder="Max Price">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Stock Number</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.stock_number" placeholder="Stock Number">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Location</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.location" placeholder="Location">
      </div>

      <!-- Row 3: Mileage and Engine -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Mileage From</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.mileage_from">
          <option value="">Any Mileage</option>
          <option *ngFor="let mileage of mileageOptions" [value]="mileage.value">{{ mileage.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Mileage To</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.mileage_to">
          <option value="">Any Mileage</option>
          <option *ngFor="let mileage of mileageOptions" [value]="mileage.value">{{ mileage.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Engine CC</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.engine_cc">
          <option value="">Any Engine</option>
          <option *ngFor="let engine of engineCCOptions" [value]="engine.value">{{ engine.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Fuel Type</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.fuel_type">
          <option value="">All Types</option>
          <option *ngFor="let fuel of fuelTypesList" [value]="fuel.value">{{ fuel.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Transmission</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.transmission">
          <option value="">All Types</option>
          <option *ngFor="let trans of transmissionList" [value]="trans.value">{{ trans.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Steering</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.steering">
          <option value="">Any Steering</option>
          <option *ngFor="let steering of steeringOptions" [value]="steering.value">{{ steering.label }}</option>
        </select>
      </div>

      <!-- Row 4: Color and Options -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Color</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.color">
          <option value="">Any Color</option>
          <option *ngFor="let color of colorsList" [value]="color.value">{{ color.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">One Price Data</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.one_price_data">
          <option value="">Any</option>
          <option *ngFor="let option of onePriceDataOptions" [value]="option.value">{{ option.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Source</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.source">
          <option value="">Any Source</option>
          <option *ngFor="let source of sourceOptions" [value]="source.value">{{ source.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Status</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.status">
          <option value="">Any Status</option>
          <option *ngFor="let status of statusOptions" [value]="status.value">{{ status.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Display</label>
        <div class="d-flex gap-3 mt-2">
          <div class="form-check">
            <input class="form-check-input" type="radio" name="display" id="display_active" value="active" [(ngModel)]="filters.display">
            <label class="form-check-label fs-7" for="display_active">Active</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="display" id="display_inactive" value="inactive" [(ngModel)]="filters.display">
            <label class="form-check-label fs-7" for="display_inactive">In Active</label>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Purchase Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.date_from">
      </div>

      <!-- Row 5: Dates -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Purchase Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.date_to">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard In Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.yard_in_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard In Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.yard_in_date_to">
      </div>

      <!-- Row 6: Date Filters -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">From Sailing Date</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.etd_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">To Sailing Date</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.etd_to">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">From Arrival Date</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.eta_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">To Arrival Date</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.eta_to">
      </div>
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Ship Name</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Ship..."
            [(ngModel)]="shipSearchTerm"
            (input)="onShipSearchInput($event)"
            (focus)="onShipInputFocus()"
            (blur)="onShipInputBlur()"
            autocomplete="off" />

          <!-- Ship Dropdown -->
          <div class="dropdown-menu show w-100 mt-1"
               *ngIf="showShipDropdown"
               style="position: absolute; top: 100%; left: 0; z-index: 1000; max-height: 200px; overflow-y: auto;">

            <!-- Loading -->
            <div class="dropdown-item text-center py-3" *ngIf="isShipSearching">
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Searching...
            </div>

            <!-- Results -->
            <a class="dropdown-item py-2"
               *ngFor="let ship of shipSearchResults"
               (click)="selectShip(ship)">
              <div class="fw-bold">{{ getShipDisplayName(ship) }}</div>
              <div class="text-muted fs-7">{{ ship.sailing_port }} → {{ ship.destination_port }}</div>
              <div class="text-muted fs-7" *ngIf="ship.sailing_date">Sailing: {{ formatDate(ship.sailing_date) }}</div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isShipSearching && shipSearchResults.length === 0">
              No ships found
            </div>
          </div>
        </div>
      </div>

      <!-- Row 7: Searchable Inputs -->
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sold To</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Customer..."
            [(ngModel)]="soldToSearchTerm"
            (input)="onSoldToSearchInput($event)"
            (focus)="onSoldToInputFocus()"
            (blur)="onSoldToInputBlur()"
            autocomplete="off" />

          <!-- Sold To Dropdown -->
          <div class="dropdown-menu show w-100 mt-1"
               *ngIf="showSoldToDropdown"
               style="position: absolute; top: 100%; left: 0; z-index: 1000; max-height: 200px; overflow-y: auto;">

            <!-- Loading -->
            <div class="dropdown-item text-center py-3" *ngIf="isSoldToSearching">
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Searching...
            </div>

            <!-- Results -->
            <a class="dropdown-item py-2"
               *ngFor="let soldTo of soldToSearchResults"
               (click)="selectSoldTo(soldTo)">
              <div class="fw-bold">{{ getSoldToDisplayName(soldTo) }}</div>
              <div class="text-muted fs-7" *ngIf="soldTo.email">{{ soldTo.email }}</div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isSoldToSearching && soldToSearchResults.length === 0">
              No customers found
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Purchase From</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Sales Person..."
            [(ngModel)]="purchaseFromSearchTerm"
            (input)="onPurchaseFromSearchInput($event)"
            (focus)="onPurchaseFromInputFocus()"
            (blur)="onPurchaseFromInputBlur()"
            autocomplete="off" />

          <!-- Purchase From Dropdown -->
          <div class="dropdown-menu show w-100 mt-1"
               *ngIf="showPurchaseFromDropdown"
               style="position: absolute; top: 100%; left: 0; z-index: 1000; max-height: 200px; overflow-y: auto;">

            <!-- Loading -->
            <div class="dropdown-item text-center py-3" *ngIf="isPurchaseFromSearching">
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Searching...
            </div>

            <!-- Results -->
            <a class="dropdown-item py-2"
               *ngFor="let purchaseFrom of purchaseFromSearchResults"
               (click)="selectPurchaseFrom(purchaseFrom)">
              <div class="fw-bold">{{ getPurchaseFromDisplayName(purchaseFrom) }}</div>
              <div class="text-muted fs-7" *ngIf="purchaseFrom.email">{{ purchaseFrom.email }}</div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isPurchaseFromSearching && purchaseFromSearchResults.length === 0">
              No sales persons found
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sales Person</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Sales Person..."
            [(ngModel)]="salesPersonSearchTerm"
            (input)="onSalesPersonSearchInput($event)"
            (focus)="onSalesPersonInputFocus()"
            (blur)="onSalesPersonInputBlur()"
            autocomplete="off" />

          <!-- Sales Person Dropdown -->
          <div class="dropdown-menu show w-100 mt-1"
               *ngIf="showSalesPersonDropdown"
               style="position: absolute; top: 100%; left: 0; z-index: 1000; max-height: 200px; overflow-y: auto;">

            <!-- Loading -->
            <div class="dropdown-item text-center py-3" *ngIf="isSalesPersonSearching">
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Searching...
            </div>

            <!-- Results -->
            <a class="dropdown-item py-2"
               *ngFor="let salesPerson of salesPersonSearchResults"
               (click)="selectSalesPerson(salesPerson)">
              <div class="fw-bold">{{ getSalesPersonDisplayName(salesPerson) }}</div>
              <div class="text-muted fs-7" *ngIf="salesPerson.email">{{ salesPerson.email }}</div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isSalesPersonSearching && salesPersonSearchResults.length === 0">
              No sales persons found
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filter Actions -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-sm btn-light" (click)="clearFilters()">
            <i class="ki-duotone ki-cross fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Clear Filters
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
            <i class="ki-duotone ki-magnifier fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="d-flex align-items-center justify-content-center">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Loading vehicles...
      </div>
    </div>

    <!-- No Data State -->
    <div *ngIf="!isLoading && vehicles.length === 0" class="text-center py-5">
      <div class="text-muted">No vehicles found</div>
    </div>

    <!-- Vehicles List -->
    <div *ngIf="!isLoading && vehicles.length > 0" class="vehicle-listing">
      <div *ngFor="let vehicle of vehicles; trackBy: trackByFn" class="vehicle-row mb-3">
        <div class="card border border-gray-300 shadow-sm">
          <div class="card-body p-3">
            <div class="row align-items-start">
              <!-- Vehicle Image -->
              <div class="col-1">
                <div class="vehicle-image-container d-flex justify-content-center align-items-center">
                  <div class="symbol symbol-60px" *ngIf="hasVehicleImage(vehicle)">
                    <div class="symbol-label rounded"
                      [style.background-image]="'url(' + getVehicleImageUrl(vehicle) + ')'"
                      style="background-size: cover; background-position: center;">
                    </div>
                  </div>
                  <div class="symbol symbol-60px bg-light-primary" *ngIf="!hasVehicleImage(vehicle)">
                    <div class="symbol-label rounded d-flex justify-content-center align-items-center">
                      <i class="ki-duotone ki-car fs-2 text-primary">
                        <span class="path1"></span>
                        <span class="path2"></span>
                        <span class="path3"></span>
                      </i>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Vehicle Basic Info Column 1 -->
              <div class="col-2">
                <div class="vehicle-info-section">
                  <div class="info-item">
                    <span class="label">Stock Number:</span>
                    <span class="value">{{ vehicle.car_no || vehicle.inventory_no || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Make:</span>
                    <span class="value">{{ vehicle.make || vehicle.company_name || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Model:</span>
                    <span class="value">{{ vehicle.name || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Year:</span>
                    <span class="value">{{ vehicle.year || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Reg. Year:</span>
                    <span class="value">{{ vehicle.year || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Mileage:</span>
                    <span class="value">{{ vehicle.mileage ? (vehicle.mileage | number) + ' km' : '-' }}</span>
                  </div>
                </div>
              </div>

              <!-- Vehicle Details Column 2 -->
              <div class="col-2">
                <div class="vehicle-info-section">
                  <div class="info-item">
                    <span class="label">Chassis No:</span>
                    <span class="value">{{ vehicle.vin_no || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Engine:</span>
                    <span class="value">{{ vehicle.engine || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Fuel Type:</span>
                    <span class="value">{{ vehicle.fuel_type || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Transmission:</span>
                    <span class="value">{{ vehicle.transmission || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Color:</span>
                    <span class="value">{{ vehicle.exterior_color || vehicle.color || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Body Type:</span>
                    <span class="value">{{ vehicle?.body_type_obj?.name || '-' }}</span>
                  </div>
                </div>
              </div>

              <!-- Vehicle Specifications Column 3 -->
              <div class="col-2">
                <div class="vehicle-info-section">
                  <div class="info-item">
                    <span class="label">Steering:</span>
                    <span class="value">{{ vehicle.steering || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Doors:</span>
                    <span class="value">{{ vehicle.doors || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Seats:</span>
                    <span class="value">{{ vehicle.seat_capacity || vehicle.seats || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Drive Type:</span>
                    <span class="value">{{ vehicle.drive_type || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Interior Color:</span>
                    <span class="value">{{ vehicle.interior_color || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Sales Person:</span>
                    <span class="value">{{ vehicle.sales_person?.name || '-' }}</span>
                  </div>
                </div>
              </div>

              <!-- Auction Information Column 4 -->
              <div class="col-2">
                <div class="vehicle-info-section">
                  <div class="info-item">
                    <span class="label">Auction Hall:</span>
                    <span class="value">{{ vehicle?.hall_name || vehicle.auction_house || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Auction Grade:</span>
                    <span class="value">{{ vehicle.auction_grade || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Lot Number:</span>
                    <span class="value">{{ vehicle.lot_no || vehicle.stockLotNo || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Car Page:</span>
                    <span class="value">{{ vehicle.car_page || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Auction Number:</span>
                    <span class="value">{{ vehicle.auction_number || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Car ID:</span>
                    <span class="value">{{ vehicle.inventory_no || vehicle.car_no || '-' }}</span>
                  </div>
                </div>
              </div>

              <!-- Purchase & Financial Info Column 5 -->
              <div class="col-3">
                <div class="vehicle-info-section">
                  <div class="info-item">
                    <span class="label">Purchase Date:</span>
                    <span class="value">{{ formatDate(vehicle.purchase_date || vehicle.created_at) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">FOB Price:</span>
                    <span class="value text-primary fw-bold">{{ formatPrice(vehicle.fob_price || vehicle.price)
                      }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Total Price:</span>
                    <span class="value text-success fw-bold">{{ formatPrice(vehicle.total_price || vehicle.price)
                      }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Location:</span>
                    <span class="value">{{ vehicle.location || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Yard Date:</span>
                    <span class="value">{{ formatDate(vehicle.yard_date) }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">Status:</span>
                    <span class="value" style="text-transform: capitalize;">
                      <span class="badge"  [class]="!vehicle.is_sold ? 'badge-light-success' : 'badge-light-alert'">
                        {{ vehicle.is_sold?'SOLD' : 'AVAILABLE' }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Actions Row - Moved to bottom -->
            <div class="row mt-3 pt-3 border-top border-gray-200">
              <div class="col-12">
                <div class="vehicle-actions-bottom">
                  <div class="d-flex flex-wrap gap-2 justify-content-center">
                    <!-- Edit Button -->
                    <button type="button" *ngIf="canView('edit')" class="btn btn-sm btn-primary" (click)="editVehicle(vehicle)"
                      title="Edit Vehicle">
                      Edit
                    </button>

                    <!-- Upload Documents Button -->
                    <button type="button" *ngIf="canView('upload-documents')" class="btn btn-sm btn-primary" (click)="uploadDocuments(vehicle)"
                      title="Upload Documents">
                      Upload Documents
                    </button>

                    <!-- Transport Pickup Button -->
                    <button type="button" class="btn btn-sm btn-primary" *ngIf="canView('transport-pickup')" (click)="transportPickup(vehicle)"
                      title="Transport Pickup">
                      Transport Pickup
                    </button>

                    <!-- Purchase Manager Button -->
                    <button type="button" class="btn btn-sm btn-primary" *ngIf="canView('purchase-manager')" (click)="purchaseManager(vehicle)"
                      title="Purchase Manager">
                      Purchase Manager
                    </button>

                    <!-- MASHO Manage Button -->
                    <button type="button" class="btn btn-sm btn-primary" *ngIf="canView('masho-manager')" (click)="mashoManage(vehicle)"
                      title="MASHO Manage">
                      MASHO
                    </button>

                    <!-- Export Certificate Button -->
                    <button type="button" class="btn btn-sm btn-primary" *ngIf="canView('export-certificate')" (click)="exportCertificate(vehicle)"
                      title="Export Certificate">
                      Export Certificate
                    </button>

                    <!-- Inspection Button -->
                    <!-- <button
                      type="button"
                      class="btn btn-sm btn-primary"
                      (click)="inspection(vehicle)"
                      title="Inspection">
                      Inspection
                    </button> -->

                    <!-- Vehicle Price Sheet Button -->
                    <button type="button" class="btn btn-sm btn-primary" *ngIf="canView('price-sheet')" (click)="vehiclePriceSheet(vehicle)"
                      title="Vehicle Price Sheet">
                      Vehicle Price Sheet
                    </button>

                    <!-- Vehicle Remark Button -->
                    <button type="button" class="btn btn-sm btn-primary" *ngIf="canView('remarks')" (click)="vehicleRemark(vehicle)"
                      title="Vehicle Remarks">
                      Vehicle Remarks
                    </button>

                    <!-- Upload Images Button -->
                    <button type="button" class="btn btn-sm btn-primary" *ngIf="canView('upload-images')" (click)="uploadImages(vehicle)"
                      title="Upload Images">
                      Upload Images
                    </button>

                    <!-- Vehicle Remove Button -->
                    <button type="button" class="btn btn-sm btn-danger" *ngIf="canView('remove-stock')" (click)="removeStock(vehicle)"
                      title="Remove Stock">
                      Remove Stock
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Additional Information Row -->
            <div class="row mt-3 pt-3 border-top border-gray-200"
              *ngIf="vehicle.remarks || vehicle.stockOptions || vehicle.other_specifications">
              <div class="col-12">
                <div class="additional-info">
                  <div class="row">
                    <div class="col-4" *ngIf="vehicle.remarks">
                      <span class="label">Remarks:</span>
                      <span class="value">{{ vehicle.remarks }}</span>
                    </div>
                    <div class="col-4" *ngIf="vehicle.stockOptions">
                      <span class="label">Options:</span>
                      <span class="value">{{ vehicle.stockOptions }}</span>
                    </div>
                    <div class="col-4" *ngIf="vehicle.other_specifications">
                      <span class="label">Other Specs:</span>
                      <span class="value">{{ vehicle.other_specifications }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="d-flex flex-stack flex-wrap pt-10" *ngIf="!isLoading && vehicles.length > 0">
      <div class="fs-6 fw-semibold text-gray-700">
        Showing {{ (paginationInfo.currentPage - 1) * paginationInfo.perPage + 1 }} to
        {{ Math.min(paginationInfo.currentPage * paginationInfo.perPage, paginationInfo.total) }}
        of {{ paginationInfo.total }} entries
      </div>

      <ul class="pagination" *ngIf="paginationInfo.lastPage > 1">
        <li class="page-item" [class.disabled]="paginationInfo.currentPage === 1">
          <a class="page-link" (click)="onPageChange(paginationInfo.currentPage - 1)"
            [class.disabled]="paginationInfo.currentPage === 1">
            <i class="previous"></i>
          </a>
        </li>

        <li class="page-item" *ngFor="let page of [].constructor(paginationInfo.lastPage); let i = index"
          [class.active]="i + 1 === paginationInfo.currentPage">
          <a class="page-link" (click)="onPageChange(i + 1)">{{ i + 1 }}</a>
        </li>

        <li class="page-item" [class.disabled]="paginationInfo.currentPage === paginationInfo.lastPage">
          <a class="page-link" (click)="onPageChange(paginationInfo.currentPage + 1)"
            [class.disabled]="paginationInfo.currentPage === paginationInfo.lastPage">
            <i class="next"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>

<!-- Vehicle Upload Documents Modal -->
<app-vehicle-upload-documents (documentsUploaded)="onDocumentsUploaded()"></app-vehicle-upload-documents>
